import script from "./ViewADocumentLive.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewADocumentLive.vue?vue&type=script&setup=true&lang=js"

import "./ViewADocumentLive.vue?vue&type=style&index=0&id=8c7a00e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7a00e0"]])

export default __exports__